import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { authService } from "../services/api.service";
import logger from "../utils/logger";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = authService.checkAuth();

  logger.debug("🔒 Protected Route Check:", {
    isAuthenticated,
    path: location.pathname,
  });

  // ⚠️ CRITICAL: تحقق أولاً من كون الصفحة عامة
  // لتجنب loop لانهائي وإعادة التوجيه غير الضرورية
  const publicPaths = [
    "/subscription-expired",
    "/payment-pending",
    "/contact-support",
    "/checkout"
  ];
  
  if (publicPaths.some(path => location.pathname === path)) {
    logger.debug(`✅ ${location.pathname} - Public page, bypassing authentication and subscription check`);
    return children;
  }

  // Check authentication for non-public routes
  if (!isAuthenticated) {
    logger.warn("❌ Not authenticated - Redirecting to /login");
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check subscription status
  const subscriptionData = localStorage.getItem("subscription");
  if (subscriptionData) {
    try {
      const subscription = JSON.parse(subscriptionData);
      logger.debug("📊 Subscription Check in ProtectedRoute:", {
        isActive: subscription.isActive,
        requiresAction: subscription.requiresAction,
        status: subscription.status,
      });

      // If subscription is not active, redirect to subscription expired page
      if (subscription.isActive === false || subscription.requiresAction) {
        logger.warn(
          "⛔ Subscription expired or requires action - Redirecting to /subscription-expired"
        );
        return <Navigate to="/subscription-expired" replace />;
      }

      logger.debug("✅ Subscription is active - Allowing access");
    } catch (error) {
      logger.error("❌ Error parsing subscription data:", error);
    }
  } else {
    logger.warn("⚠️ No subscription data in localStorage");
  }

  return children;
};

export default ProtectedRoute;
